import { load } from "./localStorage"
import { LOCAL_STORAGE_KEY } from "./dataStore"

const getDefaultBlackFridayCountdownValue = () => {
  // If isn't enabled then return null
  if (!pipelineConfig.frontendCustomFields) {
    return null
  }
  // If isn't enabled then return null
  const { black_friday_discount } = pipelineConfig.frontendCustomFields
  if (!black_friday_discount || black_friday_discount.value <= 0) {
    return null
  }

  // If is enabled then try return value from storage, as user has mb. already started countdown
  const data = load(LOCAL_STORAGE_KEY)
  if (data && data.values && data.values.blackFridayCountdown) {
    return data.values.blackFridayCountdown
  }

  // If is enabled and isn't in storage then return default value
  return {
    days: Math.floor(black_friday_discount.value / 86400),
    hours: Math.floor((black_friday_discount.value % 86400) / 3600),
    minutes: Math.floor((black_friday_discount.value % 3600) / 60),
    seconds: black_friday_discount.value % 60,
    value: black_friday_discount.value,
    isStarted: false
  }
}

export { getDefaultBlackFridayCountdownValue }
